// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "@babel/polyfill";
import Vue from "vue";
import App from "./App";
import router from "./router";
import BootstrapVue from "bootstrap-vue";
import store from "@/store/index";
import Slick from "vue-slick";
import Meta from "vue-meta";
import VueHead from "vue-head";
import VueLocalStorage from "vue-localstorage";
import GSignInButton from "vue-google-signin-button";
import FBSignInButton from "vue-facebook-signin-button";
import Carousel3d from "vue-carousel-3d";
import VueFriendlyIframe from "vue-friendly-iframe";
import VueScrollTo from "vue-scrollto";
import VeeValidate from "vee-validate";
import * as VueGoogleMaps from "vue2-google-maps";
import languageData from "@/languageData.json";
import languageDataksa from "@/languageDataksa.json";
import ReactSnapPixel from "react-snapchat-pixel";
import ReactPixel from "react-facebook-pixel";
import VueAnalytics from "vue-analytics";
// import VueGtag from "vue-gtag";
import Toasted from "vue-toasted";
// import VueTelInput from "vue-tel-input";
import VueTelInput from "../src/components/telinput";
import { LanguageService, CountryService } from "@/services/storage.service";
import VCalendar from "v-calendar";
import VueFacebookPixel from "vue-facebook-pixel";

import "v-calendar/lib/v-calendar.min.css";
import VueQrcodeReader from "vue-qrcode-reader";
import Multiselect from "vue-multiselect";
import VueLazyload from "vue-lazyload";
import ReadMore from "vue-read-more";
import OTPInput from "vue-otp-input";
import { BASEURL_BRIJ, ImageS3URL } from "@/config/index";
// LOADER COMPONENT
// Import component
import Loading from "vue-loading-overlay";
import VuePhoneNumberInput from "vue-phone-number-input";

import LightBox from "lightbox2";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// import "intl-tel-input/build/css/intlTelInput.css";
import "@/assets/css/fancybox.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./assets/css/header.css";
import "slick-carousel/slick/slick.css";
import "./assets/css/slick-theme.css";
import "./assets/css/ar.css";
// import "./assets/css/responsive.css"
import "animate.css";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import "./assets/css/newstyle.css";
// import SWJS from "../public/sw";
import CryptoJS from "crypto-js";
import _ from "lodash";
// import "lightbox2/dist/css/lightbox.min.css";
// import "lightbox2/dist/js/lightbox.js";
// import "./assets/css/responsive.css"

Vue.use(BootstrapVue);
Vue.use(LightBox);

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: "/static/img/logo_p_ver.png",
  loading: "/static/img/logo_p_ver.png",
  attempt: 1,
});
Vue.use(VueTelInput);
Vue.use(VueScrollTo);
Vue.use(VCalendar);
Vue.use(VeeValidate);
Vue.component("slick", Slick);
Vue.use(Carousel3d);
Vue.use(GSignInButton);
Vue.use(FBSignInButton);
Vue.use(VueHead);
Vue.use(Meta);
Vue.use(Loading);
Vue.use(VueQrcodeReader);
Vue.component("multiselect", Multiselect);
Vue.use(ReadMore);

Vue.use(Toasted, {
  duration: 4000,
  position: "top-center",
  singleton: true,
  containerClass: "toast-message",
});

Vue.use(VueFacebookPixel);
Vue.component("vue-phone-number-input", VuePhoneNumberInput);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDTN4bmtcbXEqjsv8B0cx2zG15TIz6-03w", // "AIzaSyDpx-CIzu0s5C-gd8Ntp1t3fCldYbo7ccw"//"AIzaSyACDkTbwhQBjD6Ml9fJYEx35ZunrKh8KHQ"
  },
});
Vue.use(VueLocalStorage, {
  name: "persistStore",
});
Vue.config.productionTip = false;
Vue.component("vue-friendly-iframe", VueFriendlyIframe);
Vue.component("v-otp-input", OTPInput);

// Created the Event Bus for the call parent function
export const EventBus = new Vue();

// if(window.location.host == "empirecinemas.me" || window.location.host == "empirecinemas.com.sa" || window.location.host == "empire.com.lb"){
//     window.location.href = "https://empirecinemas.com"
// }

if ("serviceWorker" in navigator) {
  console.log("Inside serviceWorker Ifffff");
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/static/sw.js")
      .then((registration) => {
        console.log("ServiceWorker registered with scope:", registration.scope);
      })
      .catch((error) => {
        console.error("ServiceWorker registration failed:", error);
      });
  });
}
var secretKey = "HereIsTheMySecretKey_LOL";
let preimereToken = window.localStorage.getItem("PREIMERE");
// let preimereToken = window.localStorage.getItem("PREIMERE");
if (
  (preimereToken == "null" ||
    preimereToken == null ||
    preimereToken == "false" ||
    preimereToken == false) &&
  window.location.host != "empirepremiere.com"
) {
  window.localStorage.setItem("PREIMERE", "false");

  import("./assets/css/style.css").then((something) => {
    import("./assets/css/responsive.css");
  });
} else {
  if (window.location.host != "empirepremiere.com") {
    window.localStorage.setItem("PREIMERE", "false");

    import("./assets/css/style.css").then((something) => {
      import("./assets/css/responsive.css");
    });
  } else {
    window.localStorage.setItem("PREIMERE", "true");
    import("./assets/css/preimere-css.css").then((something) => {
      import("./assets/css/responsive.css");
    });
  }
}
let uri = window.location.search.substring(1);
let params = new URLSearchParams(uri);

if (params && params.get("lang")) {
  if (params.get("lang") == "ar") {
    // window.localStorage.setItem(
    //   'language',
    //   JSON.stringify({
    //     lang: 'ar',
    //     lang_id: 1,
    //   })
    // )
  } else {
    // window.localStorage.setItem(
    //   'language',
    //   JSON.stringify({
    //     lang: 'eng',
    //     lang_id: 2,
    //   })
    // )
  }
}

let langToken = LanguageService.getLanguage() || {
  lang: "eng",
  lang_id: 2,
};
let countryId;
let country = CountryService.getCountry();

let languageCheck = window.localStorage.getItem("language");

if (languageCheck) {
  let language_check1 = JSON.parse(window.localStorage.getItem("language"));
  if (language_check1.lang_id == 1) {
    document.title = "دور سينما إمباير: شاهد القوائم وحجز التذاكر الآن!";
  }
}

if (
  !country &&
  !window.localStorage.getItem("country") &&
  window.location.host != "empirepremiere.com" &&
  !window.location.pathname.includes("/mob") &&
  !window.location.pathname.includes("/theatre")
) {
  if (
    window.location.host == "empirepremiere.com" ||
    window.location.host == "lb.empirecinemas.com"
  ) {
    console.log("CountryName", "Lebanon");
    window.localStorage.setItem("CountryName", "Lebanon");
    countryId = 119;
    // window.localStorage.setItem(
    //   'country',
    //   JSON.stringify({
    //     CountryID: 119,
    //   })
    // )
    if (!languageCheck.hasOwnProperty("lang_id")) {
      // window.localStorage.setItem(
      //   'language',
      //   JSON.stringify({
      //     lang: 'eng',
      //     lang_id: 2,
      //   })
      // )
    }

    if (window.location.host == "empirepremiere.com") {
      window.localStorage.setItem("PREIMERE", true);
    } else if (window.location.host == "lb.empirecinemas.com") {
      window.localStorage.setItem("PREIMERE", false);
    }

    if (
      window.localStorage.getItem("footer") == null ||
      window.localStorage.getItem("footer") == "" ||
      window.localStorage.getItem("footer") == undefined
    ) {
      window.localStorage.setItem("footer", "1");
      window.location.reload();
    }
    //
    // || (languageCheck && window.location.host=='localhost:8082')
  } else if (window.location.host == "ksa.empirecinemas.com") {
    console.log("CountryName", "Saudi Arabia");
    countryId = 230;
    // window.localStorage.setItem(
    //   'country',
    //   JSON.stringify({
    //     CountryID: 230,
    //   })
    // )
    if (languageCheck == "") {
      // window.localStorage.setItem(
      //   'language',
      //   JSON.stringify({
      //     lang: 'eng',
      //     lang_id: 2,
      //   })
      // )
    }

    window.localStorage.setItem("PREIMERE", false);

    if (
      window.localStorage.getItem("footer") == null ||
      window.localStorage.getItem("footer") == "" ||
      window.localStorage.getItem("footer") == undefined
    ) {
      window.localStorage.setItem("footer", "1");
      window.location.reload();
    }
  } else if (
    window.location.host == "irq.empirecinemas.com" ||
    (languageCheck && window.location.host == "localhost:8082")
  ) {
    console.log("CountryName", "Iraq");
    window.localStorage.setItem("CountryName", "Iraq");
    countryId = 102;
    // window.localStorage.setItem(
    //   'country',
    //   JSON.stringify({
    //     CountryID: 102,
    //   })
    // )
    if (languageCheck == "") {
      // window.localStorage.setItem(
      //   'language',
      //   JSON.stringify({
      //     lang: 'eng',
      //     lang_id: 2,
      //   })
      // )
    }

    window.localStorage.setItem("PREIMERE", false);

    if (
      window.localStorage.getItem("footer") == null ||
      window.localStorage.getItem("footer") == "" ||
      window.localStorage.getItem("footer") == undefined
    ) {
      window.localStorage.setItem("footer", "1");
      window.location.reload();
    }
  } else if (
    window.location.host == "empirecinemas.com" ||
    window.location.host == "localhost:8082"
  ) {
    // router.push({
    //     path: '/landingpage'
    // })
  } else {
    countryId = 230;
    // window.location.href = 'https://empirecinemas.com'
  }
} else if (
  window.location.host == "empirepremiere.com" ||
  window.location.host == "lb.empirecinemas.com"
) {
  console.log("CountryName", "Lebanon");
  window.localStorage.setItem("CountryName", "Lebanon");
  countryId = 119;
  // window.localStorage.setItem(
  //   'country',
  //   JSON.stringify({
  //     CountryID: 119,
  //   })
  // )
  if (languageCheck == "") {
    // window.localStorage.setItem(
    //   'language',
    //   JSON.stringify({
    //     lang: 'eng',
    //     lang_id: 2,
    //   })
    // )
  }

  if (
    window.localStorage.getItem("footer") == null ||
    window.localStorage.getItem("footer") == "" ||
    window.localStorage.getItem("footer") == undefined
  ) {
    window.localStorage.setItem("footer", "1");
    window.location.reload();
  }
} else if (
  window.location.host == "ksa.empirecinemas.com" ||
  window.location.host == "localhost:8082"
) {
  console.log("CountryName", "Saudi Arabia");
  window.localStorage.setItem("CountryName", "Saudi Arabia");
  countryId = 230;
  // window.localStorage.setItem(
  //   'country',
  //   JSON.stringify({
  //     CountryID: 230,
  //   })
  // )
  if (languageCheck == "") {
    // window.localStorage.setItem(
    //   'language',
    //   JSON.stringify({
    //     lang: 'eng',
    //     lang_id: 2,
    //   })
    // )
  }

  if (
    window.localStorage.getItem("footer") == null ||
    window.localStorage.getItem("footer") == "" ||
    window.localStorage.getItem("footer") == undefined
  ) {
    window.localStorage.setItem("footer", "1");
    window.location.reload();
  }
} else if (window.location.host == "irq.empirecinemas.com") {
  console.log("CountryName", "Iraq");
  window.localStorage.setItem("CountryName", "Iraq");
  countryId = 102;
  // window.localStorage.setItem(
  //   'country',
  //   JSON.stringify({
  //     CountryID: 102,
  //   })
  // )
  if (languageCheck == "") {
    // window.localStorage.setItem(
    //   'language',
    //   JSON.stringify({
    //     lang: 'eng',
    //     lang_id: 2,
    //   })
    // )
  }

  if (
    window.localStorage.getItem("footer") == null ||
    window.localStorage.getItem("footer") == "" ||
    window.localStorage.getItem("footer") == undefined
  ) {
    window.localStorage.setItem("footer", "1");
    window.location.reload();
  }
}

Vue.mixin({
  data: function() {
    return {
      fromQrCode: "",
      langName: langToken["lang"],
      BrijBaseUrl: BASEURL_BRIJ, // default,
      content_languages: [],
      preimereToken: preimereToken,
      CountryID: country ? country["CountryID"] : countryId,
      LOADING: null,
      pr: true,
      allLanguageData:
        country && country["CountryID"] == 230
          ? languageDataksa[langToken["lang"]]
          : languageData[langToken["lang"]],
      secureStore: {
        set: function(key, value) {
          let setEncryptedData = CryptoJS.AES.encrypt(
            JSON.stringify(value),
            secretKey
          ).toString();
          window.localStorage.setItem(key, setEncryptedData);
        },
        get: function(key) {
          let getEncryptedData = window.localStorage.getItem(key);
          if (!_.isNull(getEncryptedData)) {
            return JSON.parse(
              CryptoJS.AES.decrypt(getEncryptedData, secretKey).toString(
                CryptoJS.enc.Utf8
              )
            );
          }
          return null;
        },
        remove: function(key) {
          window.localStorage.removeItem(key);
        },
      },
      sessionStore: {
        set: function(key, value) {
          let setEncryptedData = CryptoJS.AES.encrypt(
            JSON.stringify(value),
            secretKey
          ).toString();
          window.sessionStorage.setItem(key, setEncryptedData);
        },
        get: function(key) {
          let getEncryptedData = window.sessionStorage.getItem(key);
          if (!_.isNull(getEncryptedData)) {
            return JSON.parse(
              CryptoJS.AES.decrypt(getEncryptedData, secretKey).toString(
                CryptoJS.enc.Utf8
              )
            );
          }
          return null;
        },
        remove: function(key) {
          window.sessionStorage.removeItem(key);
        },
      },
    };
  },
  mounted() {
    let isQrCodeKeyValue = window.localStorage.getItem("isQrCodeKey");
    if (isQrCodeKeyValue === "InCinemaFB") {
      this.fromQrCode = true;
    } else {
      this.fromQrCode = false;
    }
  },
  computed: {
    languageChange() {
      return window.localStorage.getItem("language");
    },
    getContentLanguages() {
      return this.$store.getters.getKiosLanguage;
    },
  },
  methods: {
    showLoading: function() {
      this.hideLoading(true);
      this.$nextTick(() => {
        this.LOADING = this.$loading.show({
          color: preimereToken == "true" ? "#EDD088" : "#e70d00",
          loader: "dots",
          width: 150,
          height: 150,
          class: "css-loader",
          backgroundColor: "rgba(0, 0, 0, 0.5);",
          opacity: 0.5,
          zIndex: 99999,
        });
        document.body.classList.add("modal-open");
      });
    },

    hideLoading: function(immediate = false) {
      if (!immediate) {
        this.$nextTick(() => {
          if (this.LOADING) this.LOADING.hide();
          document.body.classList.remove("modal-open");
        });
      } else {
        if (this.LOADING) this.LOADING.hide();
        document.body.classList.remove("modal-open");
      }
    },

    /**
     * How to use Ref: [https://github.com/vuejs/vue/issues/11088#issuecomment-630287153]
     *  <template>
     *    <div>
     *      {{ getSafe(() => obj.foo.bar) }}          <!-- returns 'baz' -->
     *      {{ getSafe(() => obj.foo.doesNotExist) }} <!-- returns undefined -->
     *    </div>
     *  </template>
     */
    getSafe(
      fn,
      fallbackValue = undefined,
      useFallbackForFalsyGetSafeValue = true
    ) {
      try {
        let result = fn();

        if (!result && useFallbackForFalsyGetSafeValue) {
          result = fallbackValue;
        }

        return result;
      } catch (e) {
        return fallbackValue;
      }
    },
    currFormat(value = 0) {
      let val = value || 0;
      if (typeof val === "string") {
        val = +parseFloat(val).toFixed(4) || 0;
      }

      let cFormat;
      let precision;

      let global_options_latest = this.$store.getters.getGlobalOptions || [];

      cFormat = global_options_latest.find((x) => x.go_key == "CURR_FORMAT");
      precision = global_options_latest.find(
        (x) => x.go_key == "MIN_FRACTION_DIGITS"
      );

      cFormat = cFormat && cFormat.go_value ? cFormat.go_value : "en-US";
      precision = precision && precision.go_value ? precision.go_value : 2;

      return val.toLocaleString(cFormat, {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
      });
    },

    checkBaseUrl(data = "") {
      if (!data) return undefined;

      if (data && data.includes("S3")) {
        if (data && data.includes("http")) {
          let split_data = data.split("/");
          let checkUrl = false;
          let url = ImageS3URL;

          split_data.map((z) => {
            if (z == "S3") {
              checkUrl = true;
            }
            if (checkUrl) {
              url += "/" + z;
            }
          });

          return url.replace(/([^:]\/)\/+/g, "$1");
        } else {
          let url = `${ImageS3URL}${data}`;
          return url;
        }
      } else if (data && data.includes("http")) {
        return data.replace(/([^:]\/)\/+/g, "$1"); // .replace(/\/\//g, '/')
      } else {
        let url = `${this.BrijBaseUrl}/${data}`;
        url = url;

        if (String(url).trim() === String(this.BrijBaseUrl).trim()) {
          return undefined;
        }

        return url.replace(/([^:]\/)\/+/g, "$1"); // .replace(/\/\//g, '/')
      }
    },

    getCurrentLang() {
      return LanguageService.getLanguage() || { brij_lang_id: 1, iso_2: "en" };
    },

    movieLanguagesWithSubs(
      lang_name = "",
      sub_lang_1_iso_2 = "",
      sub_lang_2_iso_2 = ""
    ) {
      return `${lang_name || ""}${
        sub_lang_1_iso_2 ? `/${sub_lang_1_iso_2}` : ""
      }${
        !!sub_lang_1_iso_2 && !!sub_lang_2_iso_2 ? `-${sub_lang_2_iso_2}` : ""
      }`;
    },

    getLangSpecificObject(arr, language = "") {
      if (arr && arr.length > 0) {
        let obj = arr.find(
          (x) =>
            x.lang_name && x.lang_name.toLowerCase() === language.toLowerCase()
        );

        if (obj) return obj;
        else return null;
      } else {
        return null;
      }
    },

    getLangSpecificAttribute(
      languageSpecificImages,
      target_lang_id,
      attr,
      lang_id_attr = "content_lang_id",
      isObject = false,
      nestedKey = null,
      skip_content_langs_fallback = false
    ) {
      if (typeof languageSpecificImages === "string") {
        languageSpecificImages = this.getSafe(
          () => JSON.parse(languageSpecificImages),
          []
        );
      }
      if (!languageSpecificImages || languageSpecificImages.length === 0) {
        return null;
      }

      let target_obj = languageSpecificImages.find(
        (x) => x[lang_id_attr] == target_lang_id
      );

      if (
        target_obj &&
        target_obj[attr] &&
        (!Array.isArray(target_obj[attr]) ||
          (Array.isArray(target_obj[attr]) && target_obj[attr].length > 0)) &&
        (!isObject || (isObject && target_obj[attr][nestedKey]))
      ) {
        return target_obj[attr];
      }

      let content_langs = this.getContentLanguages;

      if (
        content_langs &&
        !skip_content_langs_fallback &&
        content_langs.length > 0
      ) {
        for (let content_lang of content_langs) {
          let lang_obj = this.getLangSpecificObject(
            languageSpecificImages,
            content_lang.lang_name
          );
          if (lang_obj && lang_obj[attr] && attr !== "mc_title") {
            return lang_obj[attr];
          } else {
            return null;
          }
        }
      } else {
        return null;
      }

      return null;
    },

    /**
     * transpiled from, Ref: https://stackoverflow.com/a/64489535
     *  const groupByToMap = <T, Q>(array: T[], predicate: (value: T, index: number, array: T[]) => Q) =>
     *    array.reduce((map, value, index, array) => {
     *      const key = predicate(value, index, array);
     *      map.get(key)?.push(value) ?? map.set(key, [value]);
     *      return map;
     *    }, new Map<Q, T[]>());
     */
    groupByToMap(arr = [], predicate = (x) => x) {
      // magic starts :)

      let grouped = arr.reduce((map, value, index, array) => {
        const key = predicate(value, index, array);
        // var _a, _b
        // (_b = (_a = map.get(key)) === null || _a === void 0 ? void 0 : _a.push(value)) !== null && _b !== void 0 ? _b : map.set(key, [value])
        if (map.get(key)) {
          map.get(key).push(value);
        } else {
          map.set(key, [value]);
        }

        return map;
      }, new Map());

      return grouped;
    },
  },
});

// Facebook Pixel Code

// let a = Vue.analytics.fbq.init('3730812843688962', {
//   em: localStorage.getItem('guestE') ? localStorage.getItem('guestE') : '',
// })
// console.log('a',a)

const advancedMatching = {
  em: localStorage.getItem("guestE") ? localStorage.getItem("guestE") : "",
}; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
const options = {
  autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
  debug: false, // enable logs
};
ReactPixel.init("3730812843688962", advancedMatching, options);
ReactPixel.pageView(); // For tracking page view

// Google Analytic Events

Vue.use(VueAnalytics, {
  id: "UA-146687859-1",
});
// Vue.use(VueGtag, {
//   config: { id: "UA-146687859-1" },
// });
// Snap Chat Events

const userIdentification = {
  user_email: localStorage.getItem("guestE")
    ? localStorage.getItem("guestE")
    : "",
}; // optional
const snapoptions = {
  debug: false, // enable logs
};
ReactSnapPixel.init(
  "cba3adc1-8ee4-429a-8530-3c604a6d5f83",
  userIdentification,
  snapoptions
);

// Ticktock Pixel

/* eslint-disable no-new */
let app = new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: {
    App,
  },
});



// WEBPACK FOOTER //
// ./src/main.js